/** The outline's rows (plan §5): each day, then its stops in time order; in edit mode the
 *  saved stops the draft removed follow their day struck through (restorable until the
 *  save), and removed saved days follow at the end — the records outline's flat rows
 *  (`outlineFlatRows`) two levels deep, in the tour's words. Pure; the outline derives it
 *  through `useDraftSelector`, so it re-renders only when a row appears, goes or moves. */
import type { RecordKey } from '@/features/records/draft/changeSet';
import { outlineFlatRows } from '@/features/records/outline/tree';

import { TOUR_OUTLINE, type Baselines, type Entries } from './model';

export type OutlineRow =
  | { kind: 'day'; id: number; /** 0-based day number; null for a removed day. */ index: number | null; removed: boolean }
  | {
      kind: 'slot';
      id: number;
      dayId: number;
      /** 1-based position in the day (a sequential pin's number); null when removed. */
      position: number | null;
      removed: boolean;
    };

export function outlineRows(entries: Entries | null, baselines: Baselines, tourRec: RecordKey): OutlineRow[] {
  return outlineFlatRows(TOUR_OUTLINE, entries, baselines, tourRec, 2).map((r): OutlineRow =>
    r.level === 0
      ? { kind: 'day', id: r.id, index: r.index, removed: r.removed }
      : { kind: 'slot', id: r.id, dayId: r.parentId!, position: r.index === null ? null : r.index + 1, removed: r.removed },
  );
}

export function rowKey(r: OutlineRow): string {
  return r.kind === 'day' ? `d${r.id}${r.removed ? 'x' : `@${r.index}`}` : `s${r.id}@${r.dayId}${r.removed ? 'x' : `#${r.position}`}`;
}

export function outlineKey(rows: readonly OutlineRow[]): string {
  return rows.map(rowKey).join(',');
}
